import { useState } from 'react';

import { useView } from '@/hooks';
import { Button, Typography } from '@/ui';

import CoachesList from './List';

const MemberCoaches = () => {
  const { selectedUser } = useView();
  const [modalOpen, setModalOpen] = useState(false);
  const openAddModal = () => setModalOpen(true);
  const closeAddModal = () => setModalOpen(false);

  return (
    <div className="flex-1 bg-sage-100 p-0 sm:p-4 md:p-8">
      <div className="container mx-auto max-w-screen-lg p-4">
        <div className="flex justify-between">
          <Typography variant="h4">Coaches</Typography>
          <Button variant="outlined" onClick={openAddModal}>
            Add coach
          </Button>
        </div>

        <CoachesList
          client={selectedUser}
          closeModal={closeAddModal}
          modalOpen={modalOpen}
        />
      </div>
    </div>
  );
};

export default MemberCoaches;
